(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-product-video]').forEach((videoWrapper) => {
    const playButton = videoWrapper.querySelector('[data-about-product-play]');
    const video = videoWrapper.querySelector('video');

    if (!playButton || !video) return;

    playButton.addEventListener('click', () => {
      videoWrapper.classList.add('is-playing');
      video.setAttribute('controls', '');
      video.muted = false;
      video.play();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-selling-points"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-section-type="product-selling-points"]');
    if (!section) return;

    const features = section.querySelectorAll('[data-psp-feature]');
    const dots = section.querySelectorAll('.product-selling-points__visual--desktop [data-psp-dot]');
    const featureButtons = section.querySelectorAll('[data-psp-feature-btn]');

    function setActive(index) {
      const idx = Number(index);

      features.forEach((feature) => {
        feature.classList.toggle('is-active', Number(feature.dataset.pspIndex) === idx);
      });

      dots.forEach((dot) => {
        dot.classList.toggle('is-active', Number(dot.dataset.pspIndex) === idx);
      });
    }

    function clearActive() {
      features.forEach((feature) => feature.classList.remove('is-active'));
      dots.forEach((dot) => dot.classList.remove('is-active'));
    }

    featureButtons.forEach((button) => {
      const feature = button.closest('[data-psp-feature]');
      if (!feature) return;

      const index = feature.dataset.pspIndex;

      button.addEventListener('mouseenter', () => setActive(index));
      button.addEventListener('focus', () => setActive(index));
    });

    dots.forEach((dot) => {
      dot.addEventListener('mouseenter', () => setActive(dot.dataset.pspIndex));
      dot.addEventListener('focus', () => setActive(dot.dataset.pspIndex));
    });

    const layout = section.querySelector('.product-selling-points__layout');
    if (layout) {
      layout.addEventListener('mouseleave', clearActive);
    }

    const accordions = section.querySelectorAll('[data-psp-accordion]');
    accordions.forEach((accordion) => {
      accordion.addEventListener('toggle', () => {
        if (!accordion.open) return;

        accordions.forEach((item) => {
          if (item !== accordion) {
            item.open = false;
          }
        });

        const panelDots = accordion.querySelectorAll('[data-psp-dot]');
        const activeIndex = accordion.dataset.pspIndex;

        const panelDot = accordion.querySelector('[data-psp-dot]');
        if (panelDot) {
          panelDot.classList.add('is-active');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
